export default function totalPages(count: number, perPage: number): number {
    return Math.ceil(count / perPage)
}
